import { useSelector } from 'react-redux';
import { State } from '../core/reducers';
import { Feature } from '@api/v1';

/**
 * Returns true if the currently authenticated user has the given feature.
 * Reads from state.auth.user.features (array of strings).
 */
export function useFeature(feature: `${Feature}`) {
	const features: string[] = useSelector((state: State) => state.auth.user?.features || []);
	return features.includes(feature);
}
